import React from 'react';

export function ConnectionState({ isConnected }) {
  return <p>Status: { '' + isConnected ? 'Connected' : 'Disconnected' }</p>;
}